import { UrlConstants } from "../url.constants";
export class ApiStreetNamingConstants {
    static URL = UrlConstants.API_V2 + "StreetNaming";
    static FUNCTION_SET_ZONES = "SetTownPlanningZones";
    static FUNCTION_SET_APPLICATION_TYPES = "SetTownPlanningApplicationTypes";
    static FUNCTION_GET_DISTINCT_APPLICATION_TYPES = "GetDistinctApplicationTypes";
    static FUNCTION_SET_APPLICANT_AND_APPLICANT_AGENT = "SetStreetNamingApplicantAndApplicantAgent";
    static FUNCTION_SET_PROPERTIES = "SetTownPlanningProperties";
    static FUNCTION_GET_GENERATE_INVOICE = "GenerateStreetNamingInvoiceReport";
    static FUNCTION_GET_GENERATE_REQUIRED_DOCUMENTS_CHECKLIST = "GetTownPlanningRequiredDocumentsChecklist";
    static FUNCTION_GET_EXTERNAL_LINKS = "GetExternalLinks";
    static FUNCTION_APPLICATION_TYPES = "GetStreetNamingApplicationTypes";
}
